import styled from 'styled-components';

export const RichTextEditorWrap = styled.div`
    .rdw-editor-toolbar {
        margin-bottom: 0;
        border-bottom: 0;
        border-color: ${({ theme }) => theme.borderPaleGrey};
    }

    .rdw-option-wrapper {
        height: 25px;
        min-width: 30px;
        border-color: ${({ theme }) => theme.borderPaleGrey};

        &[disabled] {
            opacity: 0.5;
            cursor: not-allowed;
        }

        &:hover {
            box-shadow: none;
            border-color: ${({ theme }) => theme.primary.fg};
        }

        &:active {
            box-shadow: 1px 1px 0px #bfbdbd inset;
        }
    }

    .rdw-option-active {
        box-shadow: none;
        border-color: ${({ theme }) => theme.primary.fg};
    }

    .rdw-editor-main {
        padding: 0 5px;
        height: ${({ size }) => (size ? size : '250px')};
        line-height: 1.5;
        border: 1px solid ${({ theme }) => theme.borderPaleGrey};
    }
`;
